import { render, staticRenderFns } from "./MatterAddMatterTypeForm.vue?vue&type=template&id=24b98986&"
import script from "./MatterAddMatterTypeForm.vue?vue&type=script&lang=js&"
export * from "./MatterAddMatterTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports